/* 囲み付き文字列 */
import React from 'react';
import { Form } from 'react-bootstrap';
import { convertLine } from '../Convert';
var EnclosedString = function (_a) {
    var label = _a.label, bold = _a.bold, color = _a.color, css_class = _a.css_class;
    //太字の規定値
    var bold_css = typeof bold !== 'undefined' && bold === true ? 'font-weight-bold' : '';
    //色の規定色
    color = typeof color === 'undefined' ? 'text-dark' : color;
    // CSSクラスの規定値
    css_class = typeof css_class === 'undefined' ? '' : css_class;
    return (React.createElement(Form.Row, null,
        React.createElement("div", { className: "p-1 " + bold_css + " " + color + " " + css_class }, convertLine(label))));
};
export default EnclosedString;
